import { toast } from "react-toastify";
import style from "./UpdatePassword.module.css";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { sentMailService } from "../../stores/slices/supertokens/sentMailSlice";
import { useEffect, useState } from "react";
import { verifyEmailService } from "../../stores/slices/supertokens/verifyEmailSlice";
import { supertokenRevokeService } from "../../stores/slices/supertokens/supertokenRevokeSlice";
import { passworlessSignUpService } from "../../stores/slices/supertokens/passwordlessSignUpSlice";
import Loader from "../menu/Loader";
import { getUserData } from "../../utilities/API/supertokenServices";
import Session from "supertokens-web-js/recipe/session";

const VerifyEmail = () => {
   const navigate =useNavigate()
   const dispatch =useDispatch()
   const [searchParam] = useSearchParams();
   const [verificationMailData, setVerificationMailData] = useState({
    mailVerification: "",
    email: "",
    id: ""
   })
   const [loader, setLoader] = useState(false)

   const deleteAllCookies = () => {
    document.cookie.split(';').forEach(cookie => {
      const eqPos = cookie.indexOf('=');
      const name = eqPos > -1 ? cookie.substring(0, eqPos) : cookie;
      document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT';
    });
  }

    useEffect( async ()=>{
      deleteAllCookies()
    setLoader(true)
    const token = searchParam.get('token');
    const paramEmail = searchParam.get('email');
    const paramId = searchParam.get('id');
    setVerificationMailData((preState)=>({
      ...preState,
        email:paramEmail,
        id:paramId
    }))
    const tokenFromUrl2 = searchParam.get('tenantId');
    let getUsersDetails = await getUserData(paramId)
    // let mail = await verifyEmail(token)
    // await Session.attemptRefreshingSession()
    const verifyMail = await dispatch(verifyEmailService(token))
    setVerificationMailData((preState)=>({
      ...preState,
      mailVerification: verifyMail?.payload?.res,
    }))
    if (verifyMail?.payload?.res?.status == "OK") {
      (getUsersDetails?.loginMethods?.length == 1) && dispatch(passworlessSignUpService(paramEmail))
      // dispatch(supertokenRevokeService(paramId))
      setLoader(false)
      toast.success("Email Verified Successfully")
      setTimeout(() => {
        window.location.assign(window.location.origin);
      }, 3000);
    } else {
      (getUsersDetails?.loginMethods?.length == 1) && dispatch(passworlessSignUpService(paramEmail))
      // dispatch(supertokenRevokeService(paramId))
      setLoader(false)
      toast.error("Link is invalid")
    }
},[])

const resendVerificationMail = async () => {
  setLoader(true)
    const data = {
      email: verificationMailData.email,
      id: verificationMailData.id
    }

    const mailSent = await dispatch(sentMailService(data))
    if (mailSent?.payload?.res?.msg == "Mail sent successfully") {
      setLoader(false)
      toast.success("Verification Mail sent to Your Resgistered Email Address")
    }else if(mailSent?.payload?.res?.msg == "Email address already verified"){
      toast.success("Email address already verified")
      setLoader(false)
      setTimeout(() => {
        window.location.assign(window.location.origin);
      }, 3000);
    } else {
      setLoader(false)
      toast.error("Some thing went wrong, Please try again in a few minutes")
    }
  }
  const returnNavigate = () => {
    // navigate('/');
      window.location.assign(window.location.origin);
  };
  return (
    <>
      <div
        className={`${style.basic_container} d-flex justify-content-center `}
      >
        <div className="bg-white intro-y g-col-12 g-col-md-6 g-col-lg-4 p-5">
                  <h6 className="text-center fs-xl fw-bold color-black pb-3">
                  Welcome to the Patient Partner Portal
                  </h6>
                  <div className="pb-3 text-justify">
                    <p>The link to validate your email address may have expired. Click <span className="color-danger" style={{ cursor: "pointer" }} onClick={resendVerificationMail}>here</span> to resend the verification email.</p>
                    <p className="pt-2">If you have validated your email address, please login to the portal.</p>
                    <p className="pt-2">If you have not validated your email address, click <span className="color-danger" style={{ cursor: "pointer" }} onClick={resendVerificationMail}>here</span> to send a new link to your email.</p>
                  </div>
                  <div className="text-center pt-3">
                    <button className="btn BtnStyle" onClick={returnNavigate } id="login">Back to Login</button><br />
                  </div>
        </div>
      </div>
      {loader ? <Loader /> : null}
    </>
  );
};
export default VerifyEmail;
